/**
 * @file sanitizeHtml.js
 * @description 协议 HTML 基础消毒（去掉 script / 事件属性 / javascript:）
 * @module shared/utils/sanitizeHtml
 */

/**
 * @param {unknown} html
 * @returns {string}
 */
export function sanitizeAgreementHtml(html) {
  const str = String(html ?? '')
  if (!str) return ''
  return str
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/data:/gi, '')
}
